import { render, staticRenderFns } from "./GadsBannerModal.vue?vue&type=template&id=0052592c"
import script from "./GadsBannerModal.vue?vue&type=script&lang=js"
export * from "./GadsBannerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports